<template>
    <form-container :title="stageTitle">

        <form-yes-no-radio-list 
          class="bumper"
          id="occurredAbroad" 
          v-model="occurredAbroad" 
          label="Did it occur abroad?"
          validationFieldLabel="occurredAbroad"
          validationInvalidFeedback="Please indicate whether the incident occurred abroad">
        </form-yes-no-radio-list>
        
        <transition name="fade">
              <div v-if="occurredAbroad">
                <label for="country">Country (if you answered YES above)</label>
                <select
                    class="form-control form-control-lg"
                    id="tripCountry"
                    fieldlabel="Trip Country"
                    v-model="tripCountry"
                    v-taurus-validator="'required_if:occurredAbroad,true'" >
                    <option
                        v-for="(country, index) in countries" :key="index"
                        :value="country.name">
                        {{country.name}}
                    </option>
                </select>
                <div name="tripCountry" invalidfeedback="Please select the country that you visisted"></div>

                <label>Trip start date (if you answered YES above)</label>
                <datepicker id="tripStartDate" 
                            name="Trip start date" 
                            fieldlabel="Trip start date"
                            :format="customDateFormatter" 
                            v-model="tripStartDate" 
                            :disabled-dates="disabledDatesTripStartDate()" 
                            v-taurus-validator="'required_if:occurredAbroad,true'"/>
                <div name="tripStartDate" invalidfeedback="Please select the date that the trip started"></div>

                <label>Trip end date (if you answered YES above)</label>
                <datepicker id="tripEndDate" 
                            name="Trip end date"
                            fieldlabel="Trip end date" 
                            :format="customDateFormatter" 
                            v-model="tripEndDate" 
                            :disabled-dates="disabledDatesTripEndDate()" 
                            v-taurus-validator="'required_if:occurredAbroad,true'"/>
                <div name="tripEndDate" invalidfeedback="Please select the date that the trip ended"></div>
                <br /><br />
            </div>
        </transition>

        <label for="incidentTime">Time of the incident</label>
        <timepicker id="incidentTime" 
                    fieldlabel="Incident time" 
                    v-model="timeOfIncident" 
                    v-taurus-validator="'required'"/>
        <div name="incidentTime" invalidfeedback="Please enter the time of the incident in the following format HH:MM"></div>

        
            <form-text-area 
              style="margin-top: 5px"
              v-model="incidentDescription" 
              id="description" 
              validationFieldLabel="Description" 
              :maxLength="1000" 
              label="Describe the incident (1000 characters or less)"
              validationInvalidFeedback="Please enter the details of what happened"
              rows="5"></form-text-area>

              <form-text-area 
              style="margin-top: 10px"
              v-model="incidentLocation" 
              id="locale" 
              validationFieldLabel="Location" 
              :maxLength="250" 
              label="Location of the incident (250 characters or less)"
              validationInvalidFeedback="Please enter details about where it happened"
              rows="3"></form-text-area>

        <transition name="fade">
          <div
              v-if="nextAttempted"
              class="text-danger mb-5">
              <i class="fas fa-exclamation-triangle mr-2"></i><strong>There seems to be a problem with the details you have provided.  Please check above, then click Next.</strong>
          </div>
      </transition>

      <form-alert :show="claimFormSaveMsg && claimFormSaveMsg.length > 0" :flavour="1" :resellerId="resellerIdAsNumber">{{claimFormSaveMsg}}</form-alert>
      <form-button-bar
        :back_button_enable='true'
        :back_button_show='true'
        :back_button_icon_enable='true'
        :back_button_action='() => $router.go(-1)'
        :abandon_button_show='false'
        :abandon_button_action='handleAbandonClick'
        :save_button_enable='true'
        :save_button_show='true'
        :save_button_icon_enable='true'
        :save_button_action='handleSaveClick'
        :next_button_enable='true'
        :next_button_show='true'
        :next_button_icon_enable='true'
        :next_button_action='handleNextClick' />

    </form-container>
</template>

<script>

import tigaClaimForm from '@/mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'
import FormAlert from '@/components/FormAlert.vue'
import datepicker from '@/components/taurus-datepicker/components/Datepicker.vue'
import timepicker from '@/components/taurus-timepicker/components/Timepicker.vue'
import CharCount from '@/components/CharCount.vue'
import FormTextArea from '@/components/FormTextArea.vue'
import FormYesNoRadioList from '@/components/FormYesNoRadioList.vue'
import moment from 'moment'

export default {
  name: 'incidentDetails',
  components: {
    FormContainer,
    FormAlert,
    FormButtonBar,
    datepicker,
    timepicker,
    CharCount,
    FormTextArea,
    FormYesNoRadioList
  },
  mixins: [
    tigaClaimForm
  ],
  data () {
    return {
      nextAttempted: false,
      incidentDate: null,
      incidentTime: null
    }
  },
  beforeMount () {
    this.fetchCountries()
  },
  mounted () {
    //console.log("Mounted")
    if (!this.claimformHasPolicyNumber || 
      !this.claimformHasClaimant || 
      !this.claimformHasIncidentType || 
      !this.claimformHasClaimantUKRes ||
      !this.claimformHasClaimantVATReg) {
      this.gotoStage1();
    }
  },
  watch: {

  },
  computed: {
    occurredAbroad: {
      get () {
        return this.$store.state.claimform.claimForm.data.occurredAbroad
      },
      set (value) {
        this.$store.commit('claimform/setOccurredAbroad', { occurredAbroad: value })
      }
    },
    tripCountry: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.tripCountry
      },
      set (value) {
        this.$store.commit('claimform/setTripCountry', { tripCountry: value })
      }
    },
    tripStartDate: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.tripStartDate
      },
      set (value) {
        //this.$store.commit('claimform/setTripStartDate', { tripStartDate: this.customDateFormatter(value) })
        this.$store.commit('claimform/setTripStartDate', { tripStartDate: value })
      }
    },
    tripEndDate: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.tripEndDate
      },
      set (value) {
        //this.$store.commit('claimform/setTripEndDate', { tripEndDate: this.customDateFormatter(value) })
        this.$store.commit('claimform/setTripEndDate', { tripEndDate: value })
      }
    },
    dateOfIncident: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.dateOfIncident
      },
      set (value) {
        this.$store.commit('claimform/setIncidentDate', { dateOfIncident: value })
      }
    },
    timeOfIncident: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.timeOfIncident
      },
      set (value) {
        this.$store.commit('claimform/setIncidentTime', { timeOfIncident: value })
      }
    },
    incidentDescription: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.descriptionOfIncident
      },
      set (value) {
        this.$store.commit('claimform/setIncidentDescription', { descriptionOfIncident: value })
      }
    },
    incidentLocation: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.locationOfIncident
      },
      set (value) {
        this.$store.commit('claimform/setIncidentLocation', { locationOfIncident: value })
      }
    },
    countries () {
      return this.$store.state.claimform.countries
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleNextClick () {
      if (this.checkForm()) {
        this.$router.push({ path: '10' })
      }
      this.nextAttempted = true
    },
    handleSaveClick () {
      this.saveClaimForm()
      
    },
    handleAbandonClick () {
     
      this.abandonForm(this.claimForm.formReference, () => { window.alert('ABANDONED!!') })
    },
    disabledDatesTripStartDate () {
      let defaultDate = new Date() // default to today
      if (this.tripEndDate) {
        if (this.tripEndDate < defaultDate) {
          defaultDate = this.tripEndDate
        }
      }
      return {

        from: defaultDate
      }
    },
    disabledDatesTripEndDate () {
      return {
        to: new Date(this.tripStartDate)
      }
    },
    disabledDatesInFuture () {
      return {
        from: new Date()
      }
    },
    disabledDatesInPast () {
      return {
        to: new Date()
      }
    },
    customDateFormatter (date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>

